var jade = require("C:\\Dev\\repos\\player\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var jade_debug = [ new jade.DebugItem( 1, "C:\\Dev\\repos\\player\\app\\templates\\spell-checker.jade" ) ];
try {
var buf = [];
var jade_mixins = {};
var jade_interp;
var self = locals || {};
jade_debug.unshift(new jade.DebugItem( 0, "C:\\Dev\\repos\\player\\app\\templates\\spell-checker.jade" ));
jade_debug.unshift(new jade.DebugItem( 1, "C:\\Dev\\repos\\player\\app\\templates\\spell-checker.jade" ));
buf.push("<div class=\"spellchecker-screen-wrapper\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 2, "C:\\Dev\\repos\\player\\app\\templates\\spell-checker.jade" ));
buf.push("<div class=\"overlay\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 3, "C:\\Dev\\repos\\player\\app\\templates\\spell-checker.jade" ));
buf.push("<div class=\"content-wrapper\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 4, "C:\\Dev\\repos\\player\\app\\templates\\spell-checker.jade" ));
buf.push("<span id=\"close\" onclick=\"this.parentNode.parentNode.parentNode.removeChild(this.parentNode.parentNode); return false;\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 4, jade_debug[0].filename ));
buf.push("X");
jade_debug.shift();
jade_debug.shift();
buf.push("</span>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 6, "C:\\Dev\\repos\\player\\app\\templates\\spell-checker.jade" ));
buf.push("<h3>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 6, jade_debug[0].filename ));
buf.push("Spellcheck");
jade_debug.shift();
jade_debug.shift();
buf.push("</h3>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 8, "C:\\Dev\\repos\\player\\app\\templates\\spell-checker.jade" ));
buf.push("<button class=\"refresh-button\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 8, jade_debug[0].filename ));
buf.push("refresh");
jade_debug.shift();
jade_debug.shift();
buf.push("</button>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 10, "C:\\Dev\\repos\\player\\app\\templates\\spell-checker.jade" ));
buf.push("<div style=\"height:200px;overflow-y:scroll\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 11, "C:\\Dev\\repos\\player\\app\\templates\\spell-checker.jade" ));
buf.push("<table class=\"misspelled-words-table\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 12, "C:\\Dev\\repos\\player\\app\\templates\\spell-checker.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 13, "C:\\Dev\\repos\\player\\app\\templates\\spell-checker.jade" ));
buf.push("<td>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 13, jade_debug[0].filename ));
buf.push("Title");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 14, "C:\\Dev\\repos\\player\\app\\templates\\spell-checker.jade" ));
buf.push("<td>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 14, jade_debug[0].filename ));
buf.push("Time");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 15, "C:\\Dev\\repos\\player\\app\\templates\\spell-checker.jade" ));
buf.push("<td>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 15, jade_debug[0].filename ));
buf.push("Subtitle");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.shift();
buf.push("</table>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();;return buf.join("");
} catch (err) {
  jade.rethrow(err, jade_debug[0].filename, jade_debug[0].lineno, ".spellchecker-screen-wrapper\r\n\t.overlay\r\n\t.content-wrapper\r\n\t\tspan#close(onclick='this.parentNode.parentNode.parentNode.removeChild(this.parentNode.parentNode); return false;') X\r\n\r\n\t\th3 Spellcheck\r\n\t\t\r\n\t\tbutton.refresh-button refresh\r\n\r\n\t\tdiv(style=\"height:200px;overflow-y:scroll\")\r\n\t\t\ttable.misspelled-words-table\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd Title\r\n\t\t\t\t\ttd Time\r\n\t\t\t\t\ttd Subtitle\r\n\t\t\r\n\t\t\r\n\t\t");
}
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/spell-checker.jade
// module id = 421
// module chunks = 0